import { createMuiTheme } from "@material-ui/core/styles";
export default createMuiTheme({
  palette: {
    primary: {
      main: "rgb(41, 98, 117)",
    },
    secondary: {
      main: "rgb(41, 98, 117)",
    },
  },
});
